"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Container = _interopRequireDefault(require("../Container"));
var _Logo = _interopRequireDefault(require("./Logo"));
var _PhoneMain = _interopRequireDefault(require("../PhoneMain"));
var _styles = require("./styles");
const Header = (props, ref) => {
  const {
    left,
    right,
    LogoProps,
    withButton,
    ButtonProps,
    PhoneProps,
    sticky,
    children,
    withShadow = false,
    backgroundColor,
    ABphone
  } = props;
  const classes = (0, _styles.useHeaderStyles)(props);
  const phoneClasses = (0, _styles.usePhoneStyles)(PhoneProps);
  const buttonClasses = (0, _styles.useButtonStyles)(ButtonProps);
  return /*#__PURE__*/_react.default.createElement("header", {
    className: (0, _classnames.default)(classes.header, {
      [classes.headerStatic]: !sticky
    }, {
      [classes.headerShadow]: withShadow
    }, {
      [classes.headerBackground]: backgroundColor
    }),
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: classes.container
  }, left || /*#__PURE__*/_react.default.createElement("div", {
    className: classes.leftBlock
  }, /*#__PURE__*/_react.default.createElement(_Logo.default, LogoProps)), right || /*#__PURE__*/_react.default.createElement("div", {
    className: classes.rightBlock
  }, /*#__PURE__*/_react.default.createElement(_PhoneMain.default, (0, _extends2.default)({}, PhoneProps, {
    classes: phoneClasses,
    ABphone: ABphone
  })), withButton && /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, ButtonProps, {
    classes: buttonClasses
  })))), children);
};
const ForwardedHeader = /*#__PURE__*/_react.default.forwardRef(Header);
ForwardedHeader.defaultProps = {
  LogoProps: {},
  ButtonProps: {
    children: "Оформить"
  },
  PhoneProps: {},
  sticky: true,
  ABphone: false
};
var _default = ForwardedHeader;
exports.default = _default;